import BaseClass from "../BaseClass";

export default class VisibilitySelector extends BaseClass {

    constructor(element) {

        super(element);
        this.$radioInputs = null;
        this.$checkboxInputs = null;
        this.$buttons = null;

        let mySelf = this;

        this.clickHandler = function (event) {
            mySelf.setVisibility(event.target);
        };

        this.init();
    }

    init() {
        this.$radioInputs = this.$element.find("input:radio");
        if (this.$radioInputs.length > 0) {
            this.$radioInputs.on("click", this.clickHandler);
        }

        this.$checkboxInputs = this.$element.find("input:checkbox");
        if (this.$checkboxInputs.length > 0) {
            this.$checkboxInputs.on("click", this.clickHandler);
        }

        this.$buttons = this.$element.find('[data-type="visibilitybutton"]');
        if (this.$buttons.length > 0) {
            this.$buttons.on('click', this.clickHandler);
        }
    }

    setVisibility(selectedElement) {
        // optimierung offen (nur einmal aufs dom zugreifen, statt in schleife)
        const mySelf = this;
        const $input = $(selectedElement);

        let enableContainer = $input.attr('data-enable-container');
        let disableContainer = $input.attr('data-disable-container');
        let disableCheckbox = $input.attr('data-disable-checkbox');

        if (selectedElement.type == 'checkbox' && !selectedElement.checked) {
            let tempContainer = enableContainer;
            enableContainer = disableContainer;
            disableContainer = tempContainer;
        }

        if (enableContainer != undefined) {

            const enableContainerArray = enableContainer.split(',')

            if (enableContainerArray.length > 0) {
                enableContainerArray.forEach(function (element) {
                    mySelf.$element.find('[data-type="' + element + '"]').removeClass('hidden');
                    mySelf.$element.find('[data-visibility-container="' + element + '"]').removeClass('hidden');
                })
            }
        }

        if (disableContainer != undefined) {

            const disableContainerArray = disableContainer.split(',')

            if (disableContainerArray.length > 0) {
                disableContainerArray.forEach(function (element) {
                    mySelf.$element.find('[data-type="' + element + '"]').addClass('hidden');
                    mySelf.$element.find('[data-visibility-container="' + element + '"]').addClass('hidden');

                    if (disableCheckbox) {
                        mySelf.$element.find(':checkbox').prop('checked', false);
                    }
                })
            }
        }
    }

    destroyListener() {
        if (this.$radioInputs.length > 0) {
            this.$radioInputs.off("click", this.clickHandler);
        }
        if (this.$checkboxInputs.length > 0) {
            this.$checkboxInputs.off("click", this.clickHandler);
        }
    }


}